import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import CardSection from "./CardSection";
import { PaymentElement } from "@stripe/react-stripe-js";
import Styles from "./Checkoutform.module.scss";
import { Style } from "domelementtype";
import Icons from "../Layouts/Icons";
import InfiniteDotLoader from "../../utils/InfiniteDotLoader";
const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const { REACT_APP_PUBLISHABLE_KEY, REACT_APP_CLIENT_SECRET } = process.env;

  const [isPaying, setIsPaying] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const cardElement = elements.getElement(CardElement);
    if (elements == null) {
      return;
    }

    // const { error, paymentMethod } = await stripe.createPaymentMethod({
    //   type: "card",
    //   card: cardElement,
    //   total: {
    //     label: 'Demo total',
    //     amount: 1000,
    //   },
    //   billing_details: {
    //     name: "sam",
    //     address: {
    //       postal_code: 673303,
    //     },
    //   },
    // });

    var paymentRequest = stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Demo total",
        amount: 1000,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    paymentRequest.canMakePayment().then((result) => {
      if (result) {
        // Mount paymentRequestButtonElement to the DOM
      }
    });

   
  };

  const handlePay = () => {
    setIsPaying(true);
  };

  return (
    <div className={Styles.CheckoutForm}>
      <div class="product-info">
        <h3 className="product-title">Apple MacBook Pro</h3>
        <h4 className="product-price">$999</h4>
      </div>
      <div>
        <form onSubmit={handleSubmit}>
          <CardSection />
          <button
            type="submit"
            disabled={!stripe || !elements}
            className={`${Styles.CheckoutForm__button} ${
              isPaying ? Styles.paymentTriggered : ""
            }`}
            onClick={() => handlePay()}
          >
            <div className={Styles.CheckoutForm__buttonIcon}>
              <Icons icon={"icon-close"} size={16} />
            </div>
            <span>{!isPaying ? "Pay" : <InfiniteDotLoader />}</span>
          </button>
        </form>
      </div>
    </div>
  );
};
export default CheckoutForm;
